export default __webpack_public_path__ + "static/media/nimish-jain.ca3195d1.jpg";